'use client'
import { FC, useState } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from '@prismicio/next'
import ChevronDown  from '../../assets/images/icons/icon-chevron-down.svg'
import DownloadIcon  from '../../assets/images/icons/icon-download.svg'

/**
 * Props for `DownloadsList`.
 */
export type DownloadsListProps =
  SliceComponentProps<Content.DownloadsListSlice>;

/**
 * Component for "DownloadsList" Slices.
 */
const DownloadsList: FC<DownloadsListProps> = ({ slice }) => {

  const [showSection, setShowSection] = useState(true);
  // console.log(props)

  const toggleFiles = () => {
    if(showSection === false) {
      setShowSection(true)
    }
    else {
      setShowSection(false)
    }
  }
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="px-4 md:px-12 lg:px-16 font-fellix mb-24"
    >
      <div className={`${slice.primary.background ? slice.primary.background.toLowerCase() : ""} ${slice.primary.position ? slice.primary.position.toLowerCase() : ""} max-w-[1280px] mx-auto text-center`}>
          {slice.primary.title  ?
          <article className="text-[28px] font-semibold">
          <PrismicRichText field={slice.primary.title}/>
          </article>
          : null }
          {slice.primary.paragraph ?
          <PrismicRichText field={slice.primary.paragraph}/>
          : null }
          {slice.primary.section_title ? 
          <div className="accordian text-left max-w-[700px] mx-auto mt-16">
            <div className="grid grid-cols-12 gap-0">
              <div className="col-span-10 font-medium text-[20px]">
                <PrismicRichText field={slice.primary.section_title} />
              </div>
              <div className="col-span-2 flex justify-end">
                  <ChevronDown onClick={()=>toggleFiles()}/>
              </div>
            </div>
            {showSection === true ? 
            <ul className="text-left max-w-[700px] mx-auto">
              {slice.primary.downloads.map((item: any, index: number)=>{
                // console.log(item)
                return (
                  <li key={index}><PrismicNextLink field={item.link} className="inline-flex justify-between w-full border-t-[1px] border-t-jade py-6"><span className="block">{item.link_name}</span><DownloadIcon className="block"/></PrismicNextLink></li>
                )
              })}
            </ul>
            : null }
          </div>
          :
          <ul className="text-left max-w-[600px] mx-auto">
              {slice.primary.downloads.map((item: any, index: number)=>{
                return (
                  <li key={index}><PrismicNextLink field={item.link} className="inline-flex justify-between w-full"><span className="block">{item.link_name}</span><DownloadIcon className="block"/></PrismicNextLink></li>
                )
              })}
            </ul> }
        </div>
    </section>
  );
};

export default DownloadsList;
